import { PropertyDetailPopupComponent } from './property-detail-popup.component';
import { PropertyDetailPopupAnchorDirective } from './property-detail-popup-anchor.directive';


export const POPUP_COMPONENTS = [
  PropertyDetailPopupComponent,
  PropertyDetailPopupAnchorDirective,
];

export {
  PropertyDetailPopupComponent,
  PropertyDetailPopupAnchorDirective
};



// WEBPACK FOOTER //
// ./src/app/features/property/components/popup/index.ts